<script setup>
import { swalError, swalSuccess } from '@/helper';
import { get_option, update_option } from '@/services/option';
import { onMounted, ref } from 'vue';


const isLoading = ref(true)
onMounted(async()=>{
  await get_company_information()
  isLoading.value = false
})

const company_information = ref({
  ids: '',
  name: '',
  email: '',
  phone_number: ''
})

async function get_company_information(){
  let response = await get_option('company_information')
  if (response.error){
    swalError(response.result, true)
    return
  }

  company_information.value = parseInfo(response.result.data) || {}
  company_information.value.ids = response.result.data ?  response.result.data.id : ''
}

function parseInfo(result){
  if (!result){
    return {name: '', email: '', phone_number: ''} 
  }
  if (result.attributes.name ==  ''){
    return {name: '', email: '', phone_number: ''} 
  }
  let parsed = {}
  try {
    parsed = JSON.parse(result.attributes.name);
  } catch (error) {
    console.error('Invalid JSON format:', error.message);
    parsed = {name: '', email: '', phone_number: ''} 
  }
  return parsed
}

async function submitForm(type){
  if (type == 'company_information'){
    let response = await update_option(
      company_information.value.ids,
      {
        name: JSON.stringify(company_information.value)
      }
    )
    if (response.error){
      swalError(response.result, true)
      return
    }
    swalSuccess('Change has been saved')
  }
}

</script>

<template>
  <loadingCard v-if="isLoading" />
  <div v-else class="card">
    <CardHeader title="Company Information"/>
    <div class="card-body">
      <form @submit.prevent="submitForm('company_information')" class="row">
        <div class="col-6">
          <div class="mb-3">
            <label class="form-label" for="name">Business Name</label>
            <input type="text" class="form-control"
              v-model="company_information.title"
              placeholder="Business Name"
              id="title"
            >
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label class="form-label" for="name">Business Email</label>
            <input type="email" class="form-control"
              v-model="company_information.email"
              placeholder="Business Email"
              id="title"
            >
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label class="form-label" for="name">Business Phone Number</label>
            <input type="text" class="form-control"
              v-model="company_information.phone_number"
              placeholder="Business Phone Number"
              id="title"
            >
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button type="submit" class="btn btn-light-success">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</template>